import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { AddToRoleDocument } from './add.generated';

export const useAddToRole = (options: ApiOptions<typeof AddToRoleDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(AddToRoleDocument, {
    refetchQueries: [
      'RoleContentFolderList',
      'RoleDataSourceList',
      'RoleDeviceList',
      'RoleDesignFolderList',
      'RoleEventTypeList',
      'RolePlaylistFolderList',
      'RoleShowFolderList',
      'RoleUserList',
    ],

    ...useNotifications(AddToRoleDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.roles.update_success'),
    }),

    ...options,
  });
};
